<template>
  <div>
    <h3>Saved Research:</h3>
    <ul>
      <li v-for="(item, index) in savedResearch" :key="index">
        {{ item.date }} - {{ item.title }}
        <button class="mx-2" @click="$emit('edit-research', index)">Edit</button>
        <button class="mx-2" @click="$emit('delete-research', index)">Delete</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    savedResearch: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
